// src/components/dashboard/ProfileOverlay.jsx
import React from "react";
import "./profile.css"
/**
 * Profile overlay modal (avatar + contact info + logout button)
 *
 * NOTE: Logout itself is handled by parent (it toggles the logout confirm overlay).
 */
const ProfileOverlay = ({
  isOpen,
  onClose,
  currentUser,
  isStudent,
  fullName,
  avatarUrl,
  getRoleLabel,
  instructorName,
  certificationEarned,
  getUserDisplayAddress,
  triggerAvatarPicker,
  onRequestLogout,
}) => {
  if (!isOpen) return null;

    function format9(digits) {
  const s = String(digits).replace(/\D/g, "").slice(0, 10);
  if (s.length <= 3) return s;
  if (s.length <= 6) return `${s.slice(0,3)}-${s.slice(3)}`;
  return `(${s.slice(0,3)}) ${s.slice(3,6)}-${s.slice(6)}`;
}

  const addressObj = getUserDisplayAddress(currentUser);
  const phone = currentUser?.phone || currentUser?.phoneNumber || (currentUser?.contact && currentUser.contact.phone) || "";


  return (
    <div className="dash-overlay dash-profile-overlay" onClick={onClose}>
      <div className="dash-panel dash-profile-panel" onClick={(e) => e.stopPropagation()}>
        <div className="dash-profile-header">
            
         <div className="dash-avatar-orb dash-avatar-orb-medium">
  <div className="dash-avatar-face">
    
    {avatarUrl ? (
      <img src={avatarUrl} alt={fullName} />
    ) : (
      <span className="dash-avatar-initials">
        {String(fullName || "A").charAt(0).toUpperCase()}
      </span>
    )}
  </div>

  <div className="dash-avatar-ring" />


  {certificationEarned && (
    <span className="dash-avatar-medal-platinum" title="100-hr Certification Earned">
      🏅
    </span>
  )}
</div>


          <div className="dash-profile-header-text">
            <div className="dash-profile-name">{fullName}</div>
            <div className="dash-profile-role">{getRoleLabel()}</div>



            <button
              type="button"
              className="dash-chip-button dash-chip-button-secondary"
              style={{ marginTop: 10 }}
              onClick={triggerAvatarPicker}
            >
              {avatarUrl ? "Change photo" : "Add photo"}
            </button>
          </div>
        </div>

        <div className="dash-profile-body">
{certificationEarned && (
  <div className="dash-profile-cert-row">
    <div className="dash-profile-cert-pill" title="100-hour Certification Earned">
      🏅 <span>100-HR CERTIFICATION EARNED</span>
    </div>
  </div>
)}

          <div className="dash-profile-row">
            <span className="dash-profile-label">Email</span>
            <span className="dash-profile-value">{currentUser?.email || "Not set"}</span>
          </div>

          <div className="dash-profile-row">
            <span className="dash-profile-label">Phone</span>
            <span className="dash-profile-value">{format9(phone) || "Not added"}</span>
          </div>

          <div className="dash-profile-row">
            <span className="dash-profile-label">Address</span>
            <span className="dash-profile-value" style={{ maxWidth: 240 }}>
              {addressObj ? (
                <span style={{ display: "inline-block", textAlign: "right" }}>
                  {addressObj.street}
                  {addressObj.street2 ? `, ${addressObj.street2}` : ""}
                  <br />
                  {addressObj.city}
                  {addressObj.state ? `, ${addressObj.state}` : ""}
                  {addressObj.zip ? ` ${addressObj.zip}` : ""}
                </span>
              ) : (
                "Not added"
              )}
            </span>
          </div>

          {isStudent && (
            <div className="dash-profile-row">
              <span className="dash-profile-label">Instructor</span>
              <span className="dash-profile-value">{instructorName || "Assigned by your academy"}</span>
            </div>
          )}
        </div>
        

        <div className="dash-profile-footer" style={{ gap: 10, display: "flex", flexDirection: "column" }}>
          <button type="button" className="dash-chip-button dash-chip-button-wide" onClick={onClose}>
            ← Back to dashboard
          </button>

          <button
            type="button"
            className="dash-chip-button dash-chip-button-wide dash-chip-logout"
            onClick={onRequestLogout}
          >
            Log out
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfileOverlay;
